/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next"
import { LocationDesktop } from "./desktop/LocationDesktop"
import { LocationMobile } from "./mobile/LocationMobile"
import { useEffect, useState } from "react"
import { openUrl } from "../../util/openUrl"
import { MainConfig } from "../../../mainConfig/configHelper"

export const LOCATION_ID = "location"

export const Location = () => {
    const { t } = useTranslation()
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768)
        }

        checkMobile()
        window.addEventListener('resize', checkMobile)

        return () => {
            window.removeEventListener('resize', checkMobile)
        }
    }, [])

    const description = <>
        {MainConfig.ceremonyLocation.details} <br /><br /> {MainConfig.weddingLocation.details}
    </>

    return isMobile ? <LocationMobile description={description} /> : <LocationDesktop description={description} />
}

const searchLocationUrl = `https://www.google.com/maps/search/${MainConfig.ceremonyLocation.location.replace(' ', '+')}`
export const navigateToMap = () => {
    openUrl(searchLocationUrl)
}

export const navigateToZielonaBrama = () => {
    openUrl(searchLocationUrl)
}
